import React from 'react';
import { getFieldLabel } from '../../utils';
import {
    useChartStoreHiddenSeries,
    useEChartsRef,
    useLegendItems,
    useChartData,
} from '../../context';
import { useLegendInteractions } from '../../useLegendInteractions';
import './chartLegend.css';

function ChartLegend() {
    const hiddenSeries = useChartStoreHiddenSeries();
    const { getEchartsInstance } = useEChartsRef();
    const legendItems = useLegendItems();
    const { hasChartData } = useChartData();

    const { toggleSeries, isolateSeries, handleLegendMouseEnter, handleLegendMouseLeave } = useLegendInteractions({
        getEchartsInstance,
        legendItems,
    });

    if (legendItems.length === 0 || !hasChartData) {
        return null;
    }

    return (
        <div className="custom-chart-legend">
            {legendItems.map((item) => (
                <div
                    key={item.id}
                    className={`legend-item${hiddenSeries.has(item.id) ? ' legend-item--hidden' : ''}`}
                >
                    <span
                        className="legend-item-content"
                        onClick={() => toggleSeries(item.id)}
                        onDoubleClick={() => isolateSeries(item.id)}
                        onMouseEnter={() => handleLegendMouseEnter(item.id)}
                        onMouseLeave={() => handleLegendMouseLeave(item.id)}
                    >
                        <span
                            className="legend-color-indicator"
                            style={{ backgroundColor: item.color }}
                        />
                        <span className="legend-label">
                            {getFieldLabel(item.label, item.totalChange)}
                        </span>
                    </span>
                </div>
            ))}
        </div>
    );
}

export default React.memo(ChartLegend);
